import { connect } from 'react-redux';
import Users from './users';

export default connect(null)(Users);
